var FireworkConfig = /** @class */ (function () {
    function FireworkConfig() {
    }
    FireworkConfig.minStrength = 1.5;
    FireworkConfig.maxStrength = 7;
    FireworkConfig.minTrails = 10;
    FireworkConfig.maxTrails = 30;
    FireworkConfig.gravity = 5e-2;
    FireworkConfig.airResistance = 1e-3;
    FireworkConfig.numberOfStars = 150;
    FireworkConfig.fireworkLifeTime = 150;
    FireworkConfig.trailLength = 150;
    FireworkConfig.delay = 0.5;
    return FireworkConfig;
}());
export { FireworkConfig };
